import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { Input } from '../../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../../shared/http-client';
import { FormFooter } from '../../../../elements/form-footer';
import { FieldError } from '../../../../elements/field-error/field-error';
import { TextArea } from '../../../../elements/text-area';
import { DatePicker } from '../../../../elements/date-picker';
import { FileInputElement } from '../../../../elements/file-input';
import { RadioGroup } from '../../../../elements/radio-group';
import { Select } from '../../../../elements/select';
import { Toggle } from '../../../../elements/toggle';
import { RadioGroupSpecial } from '../../../../elements/radio-group-special';
import { Button } from '../../../../elements/button';

  
  // construccion del objeto yup de validacion del cuestionario
let obligado = {
     purchase_type: Yup.mixed().required('obligatorio'),
     provider: Yup.mixed().required('obligatorio'),
     start_date: Yup.mixed()
         .nullable()
         .when('purchase_type', {
             is: (val: any) => val === 'LEASING' || val === 'RENTING' || val === 'OWNERSHIP',
             then: (schema: any) => schema.required('obligatorio').typeError('obligatorio'),
             otherwise: (schema: any) => schema.notRequired().nullable(),
         }),
     end_date: Yup.mixed()
         .nullable()
         .when('purchase_type', {
             is: (val: any) => val === 'LEASING' || val === 'RENTING',
             then: (schema: any) => schema.required('obligatorio').typeError('obligatorio'),
             otherwise: (schema: any) => schema.notRequired().nullable(),
         }),
 };
  const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    purchase_type: '',
    provider: null,
    start_date: null,
    end_date: null,
    number_of_installments: '',
    installment_amount: '',
    contracted_km: '',
    calculo_km: '',
    percentual_desviacion: ''
};

export const CompraTab = ({
    item,
    onAction,
    doDelete
}: {
    item?: any;
    doDelete?: (item: any) => void;
    onAction: () => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [compraSelected, setCompraSelected] = useState<any | null>();
    const [isDeleted, setIsDeleted] = useState<boolean>(false);
    const [providers, setProviders] = useState<any | null>([]);

    useEffect(() => {
        api('/fleet/vehicle-purchases/?limit=9999', 'GET');
    }, []);




    const beforeSubmit = (values: any | null) => {
        const after = { ...values };


        after.vehicle = item;


        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        let formdata = new FormData();

        if (enviaremos.document) {
            if (enviaremos.document.document) {
                formdata.append(
                    'document',
                    enviaremos.document.document[0],
                    enviaremos.document.document[0].name
                );
            }
        }

        for (let key in enviaremos) {
            if (key !== 'document') {
                formdata.append(key, enviaremos[key] ? enviaremos[key] : "");
            }
        }

        if (isDeleted) {
            api(`/fleet/vehicle-purchases/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            if (enviaremos.id) {
                // update

                api(`/fleet/vehicle-purchases/${enviaremos.id}/`, 'PATCH', formdata, true);
            } else {
                // create

                api('/fleet/vehicle-purchases/', 'POST', formdata, true);
            }
        }
    };

    const openInNewTab = () => {
        window.open(data?.display_url, '_blank', 'noreferrer');
    };



    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('vehicle-purchases')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                } else {

                    if (state.data.results.length > 0) {
                        console.log('item', item)
                        const obj = state.data.results.find((value: any) => +value.vehicle.id === +item);
                        setData(obj);
                        setCompraSelected(obj?.purchase_type);
                    }


                    api('/fleet/vehicle-providers/?limit=9999', 'GET');
                }
            }
            if (state.path.includes('providers')) {
                setProviders(state.data.results);
            }
        }

        if (state.error) {
            console.log('state.error', state.error)
            if (state.error.name) {
                //toast.error(state.error.name[0]);
            } else {
                //toast.error(`${t('common.error.server-or-network')}`);
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className='p-4'>
                        <div className='flex w-1/2 justify-between'>
                            <div className='pt-[5px]'>
                                {/*   <RadioGroup
                                    name="compra"
                                    hor={true}
                                    //label={t('common.label.resident-type-code')}
                                    value={
                                        values.compra
                                    }
                                    items={[
                                        { id: 'R', label: t('Renting') },
                                        { id: 'L', label: t('Leasing') },
                                        { id: 'P', label: t('common.label.propriedad') }
                                    ]}

                                    onChange={(newValue) => {
                                        const compraValue = newValue['compra']; // acceso seguro
                                        setFieldValue('compra', compraValue);
                                        setCompra(compraValue);
                                    }}


                                /> */}
                                <RadioGroupSpecial
                                    name="purchase_type"
                                    label={t("common.form-label.tipo-compra")}
                                    value={values.purchase_type} // 'R', 'L', o 'P'
                                    items={[
                                        { id: 'RENTING', label: t('Renting') },
                                        { id: 'LEASING', label: t('Leasing') },
                                        { id: 'OWNERSHIP', label: t('common.label.propriedad') },
                                    ]}
                                    hor // para mostrar horizontal
                                    onChange={(val) => {
                                        console.log('✔️ Valor seleccionado:', val);
                                        setFieldValue('purchase_type', val.purchase_type); // ✅ sin errores
                                        setCompraSelected(val.purchase_type); // si usas un estado local
                                    }}
                                />

                                <FieldError
                                    touched={touched}
                                    errors={errors}
                                    field={'purchase_type'}
                                />
                            </div>
                            <div className='w-1/3'>
                                <Select
                                    name="provider"
                                    label={t('common.form-label.proveedor-vehicle')}
                                    placeholder="Select value"
                                    items={providers}
                                    value={values.provider}
                                    onChange={(value) =>
                                        setFieldValue('provider', value.provider)
                                    }
                                />
                                <FieldError
                                    touched={touched}
                                    errors={errors}
                                    field={'provider'}
                                />
                            </div>
                        </div>
                        {compraSelected == 'LEASING' || compraSelected == 'RENTING' ? <>
                            <div className='flex pt-8'>
                                <div className='pt-2'>
                                    <DatePicker
                                        name="start_date"
                                        type="date"
                                        label={t(
                                            'common.label.fecha-inicio'
                                        )}
                                        value={
                                            (data
                                                ? dayjs(
                                                    data.start_date
                                                ).format(
                                                    'YYYY-MM-DD'
                                                )
                                                : '') ||
                                            values.start_date
                                        }
                                        onChange={(value) => {
                                            setFieldValue(
                                                'start_date',
                                                value.start_date
                                                    ? dayjs(
                                                        value.start_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : null
                                            );
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'start_date'}
                                    />
                                </div>

                                <div className='pt-[8px] pl-8'>
                                    <Input
                                        label={t('common.form-label.numero-cuotas')}
                                        type="number"
                                        placeholder={t('common.form-label.numero-cuotas')}
                                        name="number_of_installments"
                                        value={values.number_of_installments}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'number_of_installments',
                                                value.number_of_installments
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'number_of_installments'}
                                    />
                                </div>

                                <div className='pt-2 pl-8'>
                                    <DatePicker
                                        name="end_date"
                                        type="date"
                                        label={t(
                                            'common.label.fecha-fin'
                                        )}
                                        value={
                                            (data
                                                ? dayjs(
                                                    data.end_date
                                                ).format(
                                                    'YYYY-MM-DD'
                                                )
                                                : '') ||
                                            values.end_date
                                        }
                                        onChange={(value) => {
                                            setFieldValue(
                                                'end_date',
                                                value.end_date
                                                    ? dayjs(
                                                        value.end_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : null
                                            );
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'end_date'}
                                    />
                                </div>
                            </div>
                            <div className='flex pt-8'>
                                <div>
                                    <Input
                                        label={t('common.form-label.importe-cuota')}
                                        type="number"
                                        placeholder={t('common.form-label.importe-cuota')}
                                        name="installment_amount"
                                        value={values.installment_amount}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'installment_amount',
                                                value.installment_amount
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'installment_amount'}
                                    />
                                </div>
                                {compraSelected && compraSelected === 'LEASING' ? <div className='pl-8'>
                                    <Input
                                        label={t('common.form-label.valor-residual')}
                                        type="number"
                                        placeholder={t('common.form-label.valor-residual')}
                                        name="residual_value"
                                        value={values.residual_value}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'residual_value',
                                                value.residual_value
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'residual_value'}
                                    />
                                </div> : ''}
                                <div className='pl-8'>
                                    <Input
                                        label={t('common.form-label.km-contratados')}
                                        type="number"
                                        placeholder={t('common.form-label.km-contratados')}
                                        name="contracted_km"
                                        value={values.contracted_km}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'contracted_km',
                                                value.contracted_km
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'contracted_km'}
                                    />
                                </div>
                                <div className='pl-8'>
                                    <Input
                                        label={t('common.form-label.calculo-km')}
                                        type="number"
                                        placeholder={t('common.form-label.calculo-km')}
                                        name="expected_km"
                                        value={values.expected_km}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'expected_km',
                                                value.expected_km
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'expected_km'}
                                    />
                                </div>

                                <div className='pl-8'>
                                    <Input
                                        label={t('common.form-label.%-desviacion')}
                                        type="number"
                                        placeholder={t('common.form-label.%-desviacion')}
                                        name="km_deviation_percentage"
                                        value={values.km_deviation_percentage}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'km_deviation_percentage',
                                                value.km_deviation_percentage
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'km_deviation_percentage'}
                                    />
                                </div>

                            </div>

                            {compraSelected == 'RENTING' ? <>

                                <div className='flex pt-8 w-full'>
                                    <div className='w-1/4'>
                                        <Toggle
                                            name="includes_maintenance"
                                            label={t('common.form-label.incluye-mantenimiento')}
                                            hasInfo
                                            value={values.includes_maintenance}
                                            onChange={(value: any) =>
                                                setFieldValue('includes_maintenance', value.includes_maintenance)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'includes_maintenance'}
                                        />
                                    </div>
                                </div>
                                <div className='flex pt-4 w-full'>
                                    <div className='w-1/4 pt-[30px]'>
                                        <Toggle
                                            name="incluye_neumaticos"
                                            label={t('common.form-label.incluye-neumaticos')}
                                            hasInfo
                                            value={values.incluye_neumaticos}
                                            onChange={(value: any) =>
                                                setFieldValue('incluye_neumaticos', value.incluye_neumaticos)
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'incluye_neumaticos'}
                                        />
                                    </div>
                                    <div className='pl-12'>
                                        <Input
                                            label={t('common.label.cantidad')}
                                            type="number"
                                            placeholder={t('common.label.cantidad')}
                                            name="number_of_wheel_changes"
                                            value={values.number_of_wheel_changes}
                                            onChange={(value) =>
                                                setFieldValue(
                                                    'number_of_wheel_changes',
                                                    value.number_of_wheel_changes
                                                )
                                            }
                                        />
                                        <FieldError
                                            touched={touched}
                                            errors={errors}
                                            field={'number_of_wheel_changes'}
                                        />
                                    </div>
                                </div>
                            </> : <>
                                <div className='w-1/4 pt-8'>
                                    <Toggle
                                        name="includes_insurance"
                                        label={t('common.form-label.incluye-seguro')}
                                        hasInfo
                                        value={values.includes_insurance}
                                        onChange={(value: any) =>
                                            setFieldValue('includes_insurance', value.includes_insurance)
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'includes_insurance'}
                                    />
                                </div>
                            </>}



                        </> : <>
                            <div className='flex pt-4'>
                                <div className='pt-2'>
                                    <DatePicker
                                        name="start_date"
                                        type="date"
                                        label={t(
                                            'common.label.fecha-compra'
                                        )}
                                        value={
                                            (data
                                                ? dayjs(
                                                    data.start_date
                                                ).format(
                                                    'YYYY-MM-DD'
                                                )
                                                : '') ||
                                            values.start_date
                                        }
                                        onChange={(value) => {
                                            setFieldValue(
                                                'start_date',
                                                value.start_date
                                                    ? dayjs(
                                                        value.start_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : null
                                            );
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'start_date'}
                                    />
                                </div>

                                <div className='pt-[8px] pl-8'>
                                    <Input
                                        label={t('common.label.importe-compra')}
                                        type="number"
                                        placeholder={t('common.label.importe-compra')}
                                        name="purchase_amount"
                                        value={values.purchase_amount}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'purchase_amount',
                                                value.purchase_amount
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'purchase_amount'}
                                    />
                                </div>
                            </div>
                            <div className='flex pt-4'>
                                <div className='pt-2'>
                                    <DatePicker
                                        name="warranty_end_date"
                                        type="date"
                                        label={t(
                                            'common.label.fecha-hasta-garantia'
                                        )}
                                        value={
                                            (data
                                                ? dayjs(
                                                    data.warranty_end_date
                                                ).format(
                                                    'YYYY-MM-DD'
                                                )
                                                : '') ||
                                            values.warranty_end_date
                                        }
                                        onChange={(value) => {
                                            setFieldValue(
                                                'warranty_end_date',
                                                value.warranty_end_date
                                                    ? dayjs(
                                                        value.warranty_end_date
                                                    ).format(
                                                        'YYYY-MM-DD'
                                                    )
                                                    : null
                                            );
                                        }}
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'fecha_hasta_garantia'}
                                    />
                                </div>

                                <div className='pt-[8px] pl-8'>
                                    <Input
                                        label={t('common.label.km-garantia')}
                                        type="number"
                                        placeholder={t('common.label.km-garantia')}
                                        name="warranty_km"
                                        value={values.warranty_km}
                                        onChange={(value) =>
                                            setFieldValue(
                                                'warranty_km',
                                                value.warranty_km
                                            )
                                        }
                                    />
                                    <FieldError
                                        touched={touched}
                                        errors={errors}
                                        field={'warranty_km'}
                                    />
                                </div>
                            </div>
                        </>}
                        <div className='pt-4'>
                            <TextArea
                                label={t(
                                    'common.label.observaciones'
                                )}
                                placeholder={t(
                                    'common.label.observaciones'
                                )}
                                name="observations"
                                value={values.observations}
                                onChange={(value: any) =>
                                    setFieldValue(
                                        'observations',
                                        value.observations
                                    )
                                }
                            />
                        </div>


                        <div className='pt-4'>
                            {data?.document ? <div className='flex'>
                                {!isDeleted ? <div className='flex cursor-pointer' onClick={openInNewTab}>
                                    <span className='border border-gray-400 rounded py-2 px-4 text-sm'>{t('common.label.ver-document')}</span>
                                </div> : ''}
                                {!isDeleted ? <div className='flex cursor-pointer ml-8' onClick={() => {
                                    setFieldValue('document', null);
                                    setFieldValue('display_url', null);
                                    setIsDeleted(true);
                                }}>
                                    <span className='border border-red-500 rounded p-2 text-sm text-red-500'>{t('common.button.delete-document')}</span>
                                </div> : ''}
                            </div> : ''
                            }
                        </div>

                        <div className='w-1/3 pb-8 pt-4'>
                            <span className="block text-sm font-semibold leading-6 text-gray-700">{data?.document ? t('common.label.cambiar-document') : t('common.form-label.documento')}</span>
                            <FileInputElement
                                name="document"
                                onChange={(value) => {
                                    // Extraemos directamente el FileList del objeto que retorna el FileInputElement
                                    setFieldValue('document', value);
                                }}
                            />
                        </div>

                    </div>

                    <div className='pl-4 pb-16'>
                        <Button
                            label={t('common.button.save')}
                            onClick={handleSubmit}
                        />
                    </div>
                </form>
            )}
        </Formik>
    );
};